export interface ConfigurableListOption {
  label: string;
  active: boolean;
}

export const IN_HOUSE_REPAIR_LOCATION = 'IN-HOUSE';

export const DEFAULT_REPAIR_LOCATIONS: ConfigurableListOption[] = [
  { label: IN_HOUSE_REPAIR_LOCATION, active: true },
  { label: 'PRO-OP', active: true },
  { label: 'IVKO', active: true },
];

export const DEFAULT_WHO_TO_CALL: ConfigurableListOption[] = [
  { label: 'Doctor', active: true },
  { label: 'Customer', active: true },
  { label: 'Vendor', active: true },
  { label: 'Other', active: true },
];

export const DEFAULT_INQUIRY_FOLLOW_UP_HOURS = 24;
export const DEFAULT_AWAITING_RX_FOLLOW_UP_HOURS = 24;
export const HOLD_RX_FOLLOW_UP_HOURS = 48;

export function normalizeConfigurableList(
  options: ConfigurableListOption[] | undefined,
  fallback: ConfigurableListOption[]
): ConfigurableListOption[] {
  const source = Array.isArray(options) ? options : [];
  const normalized = source
    .map((item) => ({
      label: String(item?.label ?? '').trim(),
      active: item?.active !== false,
    }))
    .filter((item) => item.label);
  if (!normalized.length) {
    return fallback.map((item) => ({ ...item }));
  }
  return normalized;
}

export function activeListLabels(
  options: ConfigurableListOption[] | undefined,
  fallback: ConfigurableListOption[]
): string[] {
  return normalizeConfigurableList(options, fallback)
    .filter((item) => item.active)
    .map((item) => item.label);
}

export function isOutsideRepairLocation(location?: string): boolean {
  const value = String(location || '').trim().toUpperCase();
  return !!value && value !== IN_HOUSE_REPAIR_LOCATION;
}

export function addHours(from: Date, hours: number): Date {
  return new Date(from.getTime() + hours * 60 * 60 * 1000);
}
